import { ISubscription } from 'types/subscription';
import { isMainSubscription } from 'pages/AccountSettings/components/SubscriptionsTab/components/SubscriptionCard/helpers';

const MOVE_LEFT = -1;
const MOVE_RIGHT = 1;
const STAY = 0;

export const sortFullAccessFirst = (subscriptions: Array<ISubscription>): Array<ISubscription> =>
    subscriptions.sort((a, b) => {
        if (isMainSubscription(a.product_type)) return MOVE_LEFT;
        if (isMainSubscription(b.product_type)) return MOVE_RIGHT;

        return STAY;
    });
